// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Atoms-H2-module--cls1--3fizp","cls2":"Atoms-H2-module--cls2--2eGKy Atoms-H2-module--cls1--3fizp"};